import { atom } from 'jotai';
import { Project } from '../types';

interface State {
  isOpen: boolean;
  project?: Project;
}

export const AddUserToProjectDialogAtom = atom<State>({ isOpen: false, project: undefined });
